export function rangeStepper(val: number) {
  if (val < 1000) {
    return 100;
  }
  if (val < 10_000) {
    return 1_000;
  }
  if (val < 100_000) {
    return 10_000;
  }
  if (val <= 1_00_00_000) {
    return 1_00_000;
  }
  return 1_00_00_000;
}

export const AMOUNT_INPUT_MAX = 100_00_00_000;
